// extracted by mini-css-extract-plugin
export default {"container":"U0-z","list":"V0-z"};